import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBgWl3hszIyotDqG7TuKXsubfTfQ1QufPQ",
  authDomain: "mameche-a8b61.firebaseapp.com",
  projectId: "mameche-a8b61",
  storageBucket: "mameche-a8b61.firebasestorage.app",
  messagingSenderId: "237674693061",
  appId: "1:237674693061:web:ee6992471c16de2b030bac",
  measurementId: "G-3DY0JVRG9R"
};
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
